var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.344,
    height: 19.202,
    viewBox: "0 0 19.344 19.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    transform: "translate(0.1 0.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M13.9,9.09l7.027,1.4a1.178,1.178,0,0,1,.949,1.165v8.136a1.2,1.2,0,0,1-1.2,1.2H13.5a.4.4,0,0,0,.4-.4v-.4h6.78a.4.4,0,0,0,.4-.4V11.651a.4.4,0,0,0-.311-.391L13.9,9.9Z",
    transform: "translate(-2.732 -1.983)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M18.994,14a.4.4,0,1,1,0,.8H17.4a.4.4,0,1,1,0-.8Z",
    transform: "translate(-3.44 -2.977)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M18.994,17a.4.4,0,1,1,0,.8H17.4a.4.4,0,1,1,0-.8Z",
    transform: "translate(-3.44 -3.584)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M18.994,20a.4.4,0,1,1,0,.8H17.4a.4.4,0,1,1,0-.8Z",
    transform: "translate(-3.44 -4.191)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M13.8,20.566a.4.4,0,1,1-.8,0V9.4a.424.424,0,0,1,.144-.311.419.419,0,0,1,.335-.08l.319.064V20.566Z",
    transform: "translate(-2.63 -1.965)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M12.292,23v.4a.4.4,0,0,0,.4.4H9.5a.4.4,0,0,0,.4-.4V23Z",
    transform: "translate(-1.922 -4.798)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M9.994,5a.4.4,0,1,1,0,.8H8.4a.4.4,0,1,1,0-.8Z",
    transform: "translate(-1.619 -1.156)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M10.393,8.4a.4.4,0,0,1-.4.4H8.4a.4.4,0,0,1,0-.8h1.6A.4.4,0,0,1,10.393,8.4Z",
    transform: "translate(-1.619 -1.763)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M9.994,11a.4.4,0,1,1,0,.8H8.4a.4.4,0,1,1,0-.8Z",
    transform: "translate(-1.619 -2.37)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M9.994,14a.4.4,0,1,1,0,.8H8.4a.4.4,0,0,1,0-.8Z",
    transform: "translate(-1.619 -2.977)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M5.393,14.4a.4.4,0,0,1-.4.4H3.4a.4.4,0,0,1,0-.8h1.6A.4.4,0,0,1,5.393,14.4Z",
    transform: "translate(-0.607 -2.977)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M4.994,5a.4.4,0,0,1,0,.8H3.4a.4.4,0,1,1,0-.8Z",
    transform: "translate(-0.607 -1.156)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M4.994,8a.4.4,0,0,1,0,.8H3.4a.4.4,0,0,1,0-.8Z",
    transform: "translate(-0.607 -1.763)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M4.994,11a.4.4,0,1,1,0,.8H3.4a.4.4,0,1,1,0-.8Z",
    transform: "translate(-0.607 -2.37)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M7.988,18.2a.4.4,0,0,0-.4-.4H5.2a.4.4,0,0,0-.4.4v3.59H4V18.2A1.2,1.2,0,0,1,5.2,17H7.59a1.2,1.2,0,0,1,1.2,1.2v3.59h-.8Z",
    transform: "translate(-0.809 -3.584)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M4.8,23H8.786v.4a.4.4,0,0,1-.4.4H4.4a.4.4,0,0,1-.4-.4V23Z",
    transform: "translate(-0.809 -4.798)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M1.4.2l8.766,1.332a1.192,1.192,0,0,1,1.005,1.181V7.287l-.319-.064a.419.419,0,0,0-.335.08.424.424,0,0,0-.144.311V2.709a.4.4,0,0,0-.335-.4L1.268.986A.221.221,0,0,0,1.2.978a.376.376,0,0,0-.255.1.381.381,0,0,0-.144.3V17.984a.4.4,0,0,0,.4.4H3.191v.4a.4.4,0,0,0,.4.4H1.2a1.2,1.2,0,0,1-1.2-1.2V1.377A1.175,1.175,0,0,1,.423.467,1.2,1.2,0,0,1,1.4.2Z",
    transform: "translate(0 -0.181)",
    fill: "#6b7280",
    stroke: "#6b7280",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/building-icon.714bcf6ce505ec59a0fb4db7180ad095.svg";
export { ForwardRef as ReactComponent };